import { Check } from "lucide-react";

const LABELS = ["Aantal locaties", "Locaties invoeren", "Groepen invoeren", "Controle & indienen"];

export default function WizardStepper({ step }) {
  return (
    <div className="flex items-center gap-3 text-sm text-neutral-600" data-testid="wizard-stepper">
      {LABELS.map((lbl, i) => {
        const n = i + 1;
        const active = step === n;
        const done = step > n;
        return (
          <div key={n} className="flex items-center gap-2">
            <div
              className={`h-7 w-7 rounded-full flex items-center justify-center text-xs font-medium ${
                done ? "bg-emerald-500 text-white" :
                active ? "bg-sage-600 text-white" :
                "bg-neutral-200 text-neutral-500"
              }`}
              style={done ? {} : active ? { background: "var(--sage)", color: "white" } : {}}
            >
              {done ? <Check className="h-4 w-4" /> : n}
            </div>
            <span className={active ? "font-medium text-neutral-900" : ""}>{lbl}</span>
            {n < 4 && <span className="text-neutral-300 mx-2">→</span>}
          </div>
        );
      })}
    </div>
  );
}
